import { getIsCoursePublishing } from '@/exceed';

import getIsAgendaItem from './getIsAgendaItem';

export default ({ item, isTopic, onKebabMenuItemClick, params, videoVersion }) => {
  const { orgId, type } = params;
  const rootUrl = `/videos/organizations/${orgId}/${type}`;
  const isPublishing = getIsCoursePublishing(videoVersion);
  const originalContentListItem = item.data?.metadata?.original_content_list_item;

  return [
    {
      icon: 'settings',
      key: 'properties',
      isDisabled: isPublishing,
      ...(getIsAgendaItem(params)
        ? {
            onClick: () => onKebabMenuItemClick({ action: 'properties', item }),
          }
        : {
            isLink: true,
            route: isTopic
              ? `${rootUrl}/topics/${item.id}/properties`
              : `${rootUrl}/${item.id}/properties`,
          }),
    },
    {
      icon: 'copy',
      key: 'duplicate',
      onClick: () => onKebabMenuItemClick({ action: 'duplicate', item }),
    },
    {
      icon: 'publishOutline',
      key: 'publish',
      onClick: () => onKebabMenuItemClick({ action: 'publish', item }),
    },
    {
      icon: 'moveTo',
      key: 'move-to',
      onClick: () => onKebabMenuItemClick({ action: 'moveTo', item }),
    },
    {
      icon: 'lockOutline',
      key: 'permissions',
      isLink: true,
      route: isTopic
        ? `${rootUrl}/topics/${item.id}/topic-permissions`
        : `${rootUrl}/${item.id}/video-permissions`,
    },
    {
      icon: 'shortcut',
      key: 'create-shortcut',
      onClick: () => onKebabMenuItemClick({ action: 'create_shortcut', item }),
    },
    {
      icon: 'shortcut',
      key: 'view-original',
      isLink: true,
      route: `/videos/organizations/${originalContentListItem?.organization_id}/${type}/${originalContentListItem?.id}/compose`,
    },
    {
      icon: 'deleteOutline',
      key: 'delete',
      onClick: () => onKebabMenuItemClick({ action: 'delete', item }),
    },
  ];
};
